var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2353,
    height: 2500,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E23237",
    d: "M.1 45.522 125.908.697l129.196 44.028-20.919 166.45-108.277 59.966-106.583-59.169z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B52E31",
    d: "M255.104 44.725 125.908.697v270.444l108.277-59.866z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M126.107 32.274 47.714 206.693l29.285-.498 15.739-39.347h70.325l17.233 39.845 27.99.498zm.2 55.882 26.496 55.383h-49.806z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.1e620af5cf5d70d06b616c672ac1de7b.svg";
export { ForwardRef as ReactComponent };